<svg width="24" height="5" viewBox="0 0 24 5" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M23.04 0.0800018H13.92H0.96C0.429807 0.0800018 0 0.527717 0 1.08V3.08C0 3.63229 0.429807 4.08 0.96 4.08H13.92H23.04C23.5702 4.08 24 3.63229 24 3.08V1.08C24 0.527717 23.5702 0.0800018 23.04 0.0800018Z" fill="currentColor"/>
</svg>
